
import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import React, { memo } from "react";
import strings from '../../Globalization';
import { CIResultForm } from '../../AppGrid/CIResultTable';
import { useCycleInfo } from './Context';


const CIResultFormDialog = () => {
	const {
		data,
		combos,
		ciResultFormDialogOpen,
		onCloseCIResultFormDialog,
		fullscreenDialogs: fullScreen
	} = useCycleInfo();
    const handleOnSetActiveRecord = (record) => {
        if (typeof onCloseCIResultFormDialog === 'function') {
			onCloseCIResultFormDialog(false);
		}
	};
	const handleOnSaveRecord = () => {
		if (typeof onCloseCIResultFormDialog === 'function') {
			onCloseCIResultFormDialog(true);
		}
	};
	
    return (
		!!data && (
			<Dialog
				open={ciResultFormDialogOpen}
				onClose={onCloseCIResultFormDialog}
				sx={{ '& .MuiDialog-paper': { minWidth: '60vw' }, zIndex: (theme) => theme.zIndex.tooltip }}
				fullScreen={fullScreen}
			>
				<DialogTitle>
					<Typography fontSize={'inherit'} fontWeight="inherit" color="inherit">
						{strings.CIResult}
					</Typography>
				</DialogTitle>
				<DialogContent>
					<CIResultForm
						activeRecord={{
							record: data,
							id: data?.id,
							combos
						}}
						setActiveRecord={handleOnSetActiveRecord}
						containerProps={{ elevation: 0 }}
						onRecordSaved={handleOnSaveRecord}
						disableAlerts
					/>
				</DialogContent>
			</Dialog>
		)
	);
}

export default memo(CIResultFormDialog);